module.exports = __webpack_public_path__ + "static/img/01.efb84e4d.png";